import { useState } from "react";

import { useReportFiles } from "../../hooks/fileMiscActions/useReportFiles";
import { FileReportType } from "../graphql/schema.graphql";
import { Menu, MenuItem, MenuProps } from "../ui-v2";
import { ReportTypes } from "./menu-item-icons/ReportIcon";

interface ReportFileMenuProps extends MenuProps {
  fileIds: string[];
}

export const ReportFileMenu = (props: ReportFileMenuProps) => {
  const { fileIds, ...rest } = props;
  const [selectedFileReportType, setSelectedFileReportType] =
    useState<FileReportType>();
  const { reportFiles, result: reportFilesResult } = useReportFiles();

  const handleReportFiles = (fileReportType: FileReportType) => {
    setSelectedFileReportType(fileReportType);
    reportFiles(fileIds, fileReportType);
  };

  return (
    <Menu {...rest}>
      {ReportTypes.map((reportType) => (
        <MenuItem
          key={reportType.id}
          loading={
            reportFilesResult.fetching &&
            selectedFileReportType === reportType.id
          }
          icon={reportType.icon}
          onClick={() => handleReportFiles(reportType.id)}
        >
          {reportType.name}
        </MenuItem>
      ))}
    </Menu>
  );
};
